import { setupCache } from 'axios-cache-adapter';
import CacheStore from '@/store/cache.store';
import { download } from '@/helpers';
import { DEFAULT_SUBPLOTS_PER_PAGE } from '@/store/shared.module';
import HttpService from './http.service';

const store = new CacheStore('statsCache');
const cache = setupCache({
  maxAge: 15 * 60 * 1000,
  store,
});

class StatsService extends HttpService {
  constructor() {
    super(cache);
  }

  cleanup() {
    super.cleanup();
    store.clear();
  }

  getSubplots(page, plotsPerPage, filter) {
    // devuelve recintos para el usuario identificado por token

    const params = {
      ...page && {
        offset: (page - 1) * (plotsPerPage || DEFAULT_SUBPLOTS_PER_PAGE),
      },
      ...plotsPerPage && { limit: plotsPerPage },
      ...filter && { filter },
    };

    return this.http
      .get('/subplots', { params })
      .then((response) => response.data.plots)
      .catch((error) => {
        console.log(error.response);
        throw error;
      });
  }

  getVars() {
    // devuelve lista de variables para los informes estadísticos
    return this.http
      .get('/stats/variables')
      .then((response) => response.data.variables)
      .catch((error) => {
        console.log(error);
        throw error;
      });
  }

  getSubplotYearly(subplots, variableIds, format) {
    // devuelve los valores de la producción anual
    const params = {
      subplotIds: subplots.map((subplot) => subplot.id),
      variableIds,
      ...format && { format },
    };
    return this.http
      .post(
        '/stats/subplot-yearly',
        params,
        {
          responseType: format ? 'blob' : 'json',
        },
      )
      .then((response) => {
        if (format) return download(response, 'datos.xlsx');
        return response.data.values;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  }

  getPlotDaily(plotIds, fromDate, untilDate, variableIds, format) {
    // devuelve valores para gráficas de seguimiento anual de parcelas

    const params = {
      plotIds,
      from: fromDate,
      until: untilDate,
      variableIds,
      ...format && { format },
    };
    return this.http
      .post(
        '/stats/plot-daily',
        params,
        {
          responseType: format ? 'blob' : 'json',
        },
      )
      .then((response) => {
        if (format) return download(response, 'datos.xlsx');
        return response.data.charts;
      })
      .catch((error) => {
        console.log(error.response);
        throw error;
      });
  }

  getSubplotDaily(subplots, variableIds, format) {
    // devuelve valores para gráficas de seguimiento anual de recintos

    const params = {
      subplotIds: subplots.map((subplot) => subplot.id),
      variableIds,
      ...format && { format },
    };
    return this.http
      .post(
        '/stats/subplot-daily',
        params,
        {
          responseType: format ? 'blob' : 'json',
        },
      )
      .then((response) => {
        if (format) return download(response, 'datos.xlsx');
        return response.data.charts;
      })
      .catch((error) => {
        console.log(error.response);
        throw error;
      });
  }
}

export default new StatsService();
